import { AxiosResponse, AxiosError } from 'axios';

// Constants
import {
    CROPSURE_PASSWORDS_LOAD_REQUESTED,
    CROPSURE_PASSWORDS_LOAD_SUCCEEDED,
    CROPSURE_PASSWORDS_LOAD_FAILED,
    CROPSURE_PASSWORDS_LOAD_CANCELED,
    CROPSURE_PASSWORD_CREATE_REQUESTED,
    CROPSURE_PASSWORD_CREATE_SUCCEEDED,
    CROPSURE_PASSWORD_CREATE_FAILED,
    CROPSURE_PASSWORD_UPDATE_REQUESTED,
    CROPSURE_PASSWORD_UPDATE_SUCCEEDED,
    CROPSURE_PASSWORD_UPDATE_FAILED,
    CROPSURE_PASSWORDS_SET,
    CROPSURE_PASSWORDS_DELETE,
    CROPSURE_PASSWORD_DELETE_REQUESTED,
    CROPSURE_PASSWORD_DELETE_SUCCEEDED,
    CROPSURE_PASSWORD_DELETE_FAILED
} from './constants';

// Types
import {
    RequestLoadCropsurePasswordsAction,
    SucceededLoadCropsurePasswordsAction,
    FailedLoadCropsurePasswordsAction,
    CanceledLoadCropsurePasswordsAction,
    RequestCreateCropsurePasswordAction,
    SucceededCreateCropsurePasswordAction,
    FailedCreateCropsurePasswordAction,
    RequestUpdateCropsurePasswordAction,
    SucceededUpdateCropsurePasswordAction,
    FailedUpdateCropsurePasswordAction,
    SetCropsurePasswordsAction,
    DeleteCropsurePasswordsAction,
    CropsurePasswordsState,
    CropsurePassword,
    CropsurePasswordCreatePayload,
    CropsurePasswordUpdatePayload,
    CropsurePasswordDeletePayload,
    RequestDeleteCropsurePasswordAction,
    SucceededDeleteCropsurePasswordAction,
    FailedDeleteCropsurePasswordAction
} from './types';

export function requestLoadCropsurePasswords(): RequestLoadCropsurePasswordsAction {
    return {
        type: CROPSURE_PASSWORDS_LOAD_REQUESTED
    };
}

export function succeededLoadCropsurePasswords(
    response: AxiosResponse
): SucceededLoadCropsurePasswordsAction {
    return {
        type: CROPSURE_PASSWORDS_LOAD_SUCCEEDED,
        payload: response
    };
}

export function failedLoadCropsurePasswords(
    error: AxiosError
): FailedLoadCropsurePasswordsAction {
    return {
        type: CROPSURE_PASSWORDS_LOAD_FAILED,
        payload: error,
        error: true
    };
}

export function requestCreateCropsurePassword(
    payload: CropsurePasswordCreatePayload
): RequestCreateCropsurePasswordAction {
    return {
        type: CROPSURE_PASSWORD_CREATE_REQUESTED,
        payload
    };
}

export function succeededCreateCropsurePassword(
    response: AxiosResponse
): SucceededCreateCropsurePasswordAction {
    return {
        type: CROPSURE_PASSWORD_CREATE_SUCCEEDED,
        payload: response
    };
}

export function failedCreateCropsurePassword(
    error: AxiosError
): FailedCreateCropsurePasswordAction {
    return {
        type: CROPSURE_PASSWORD_CREATE_FAILED,
        payload: error,
        error: true
    };
}

export function requestUpdateCropsurePassword(
    payload: CropsurePasswordUpdatePayload
): RequestUpdateCropsurePasswordAction {
    return {
        type: CROPSURE_PASSWORD_UPDATE_REQUESTED,
        payload
    };
}

export function succeededUpdateCropsurePassword(
    response: AxiosResponse
): SucceededUpdateCropsurePasswordAction {
    return {
        type: CROPSURE_PASSWORD_UPDATE_SUCCEEDED,
        payload: response
    };
}

export function failedUpdateCropsurePassword(
    error: AxiosError
): FailedUpdateCropsurePasswordAction {
    return {
        type: CROPSURE_PASSWORD_UPDATE_FAILED,
        payload: error,
        error: true
    };
}

export function requestDeleteCropsurePassword(
    payload: CropsurePasswordDeletePayload
): RequestDeleteCropsurePasswordAction {
    return {
        type: CROPSURE_PASSWORD_DELETE_REQUESTED,
        payload
    };
}

export function succeededDeleteCropsurePassword(
    response: AxiosResponse
): SucceededDeleteCropsurePasswordAction {
    return {
        type: CROPSURE_PASSWORD_DELETE_SUCCEEDED,
        payload: response
    };
}

export function failedDeleteCropsurePassword(
    error: AxiosError
): FailedDeleteCropsurePasswordAction {
    return {
        type: CROPSURE_PASSWORD_DELETE_FAILED,
        payload: error,
        error: true
    };
}

export function canceledLoadCropsurePasswords(): CanceledLoadCropsurePasswordsAction {
    return {
        type: CROPSURE_PASSWORDS_LOAD_CANCELED
    };
}

export function setCropsurePasswords(
    cropsurePasswords: CropsurePasswordsState
): SetCropsurePasswordsAction {
    return {
        type: CROPSURE_PASSWORDS_SET,
        payload: cropsurePasswords
    };
}

export function deleteCropsurePasswords(
    uuids: CropsurePassword['uuid'][]
): DeleteCropsurePasswordsAction {
    return {
        type: CROPSURE_PASSWORDS_DELETE,
        payload: {
            uuids
        }
    };
}
